// extracted by mini-css-extract-plugin
module.exports = {"section":"FinishedAuctions_section__1xCb5","finishedAuctionsWrapper":"FinishedAuctions_finishedAuctionsWrapper__3fpiS","tableWrapper":"FinishedAuctions_tableWrapper__1EktF"};